<script lang="ts">
	/**
	 * `/Account/Billing` while it loads: the details form in two columns of fields, the payment
	 * methods and the currency beside it — the page's own layout, so the form does not jump in.
	 */
	import Bone from './Bone.svelte';
</script>

<div role="status" aria-label="Loading your billing details" class="grid gap-6 lg:grid-cols-3 items-start animate-pulse">
	<div class="lg:col-span-2 widget bg-depth space-y-4">
		<Bone class="h-4 w-36" />
		{#each Array(4) as _row, index (index)}
			<div class="grid gap-4 sm:grid-cols-2">
				<div class="space-y-2">
					<Bone class="h-2.5 w-24" />
					<Bone class="h-10 w-full" round="xl" />
				</div>
				<div class="space-y-2">
					<Bone class="h-2.5 w-24" />
					<Bone class="h-10 w-full" round="xl" />
				</div>
			</div>
		{/each}
		<Bone class="h-9 w-28" round="xl" />
	</div>
	<div class="space-y-6">
		<div class="widget bg-depth space-y-3">
			<Bone class="h-4 w-36" />
			<Bone class="h-12 w-full" round="xl" />
			<Bone class="h-12 w-full" round="xl" />
		</div>
		<div class="widget bg-depth space-y-3">
			<Bone class="h-4 w-24" />
			<Bone class="h-3 w-2/3" />
		</div>
	</div>
	<span class="sr-only">Loading…</span>
</div>
